module.exports = __webpack_public_path__ + "assets/docusaurus.106e4564.svg";